import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69b00ba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-item record-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "我的邀请记录")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "send-cupon-tips"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 己为您发放了"),
  /*#__PURE__*/_createElementVNode("span", null, " 1 张优惠券"),
  /*#__PURE__*/_createTextVNode("，点击 "),
  /*#__PURE__*/_createElementVNode("span", { class: "ftw" }, "前往商城"),
  /*#__PURE__*/_createTextVNode(" 使用 ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "block-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-person" }, null, -1))
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "phone" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = {
  key: 0,
  class: "empty-text"
}

import { ref, withDefaults } from 'vue'
import { BindingItem } from '@/types/old-brings-new'


export default /*#__PURE__*/_defineComponent({
  __name: 'claim-record-card',
  props: {
    recordList: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { recordList: Array<BindingItem & { uuid: string }> };



const showToMall = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (showToMall.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.recordList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "van-hairline--bottom",
          key: item.uuid
        }, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.invite_user_mobile), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.create_at), 1)
          ])
        ]))
      }), 128)),
      (!__props.recordList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "暂无记录"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})